<template>
  <div>
    <v-client-table
      :data="data.rapprochements"
      :columns="columns"
      :options="options">
      <template #libelle="{ row }">
        {{ row.ligneCommandeLieuLivraison.ligneCommande.libelle }}
      </template>
      <template #codeDcf="{ row }">
        <router-link-blank
          :to="{
            name: 'c.achat.commandes',
            params: {
              id: row.ligneCommandeLieuLivraison.ligneCommande.devisCommandeId,
            },
          }"
          :message="row.ligneCommandeLieuLivraison.ligneCommande.devisCommande.code">
        </router-link-blank>
      </template>
      <template #dateDcf="{ row }">
        {{ func.formatDate(
          row.ligneCommandeLieuLivraison.ligneCommande.devisCommande.dateDevisCommande
        ) }}
      </template>
      <template #nomCommercial="{ row }">
        {{ row.ligneCommandeLieuLivraison.lieuDeLivraison.nomCommercial }}
      </template>
      <template #quantite="{ row }">
        {{ row.ligneCommandeLieuLivraison.quantite }}
      </template>
      <template #quantiteResteARapprocher="{ row, index }">
        <div class="is-flex is-align-items-center is-justify-content-right">
          <span>
            {{ row.ligneCommandeLieuLivraison.quantiteResteARapprocher }}
          </span>
          <div
            v-if="!detail"
            @click="setQuantiteValue(
              row.ligneCommandeLieuLivraison.quantiteResteARapprocher, index
            )">
            <b-icon
              icon="arrow-expand-right"
              type="is-primary"
              class="mgl-10px is-cursor-pointer">
            </b-icon>
          </div>
        </div>
      </template>
      <template #quantiteARapprocher="{ row, index }">
        <input-currency
          v-if="!detail"
          v-model="row.quantite"
          @input="setQuantiteValue($event, index)"
          isNumber="true">
        </input-currency>
        <span v-else>
          {{ row.quantite }}
        </span>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import * as tableConfig from '@/configuration/clientTableConf';
import InputCurrency from '@/components/general/inputCurrency';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'RapprochementsLigneChildRow',
  components: {
    InputCurrency,
    RouterLinkBlank,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      func: { formatDate },
    };
  },
  computed: {
    columnsData() {
      return [
        { name: 'codeDcf' },
        { name: 'nomCommercial' },
        { name: 'dateDcf' },
        { name: 'libelle' },
        { name: 'quantite' },
        { name: 'quantiteResteARapprocher' },
        { name: 'quantiteARapprocher' },
      ];
    },
    columns() {
      return this.columnsData.map((column) => column.name);
    },
    options() {
      const texts = cloneDeep(tableConfig.TEXTS);
      texts.count = '';
      const headings = this.columnsData.reduce((acc, val) => {
        const key = `${this.detail ? 'detailBonReception' : 'addEditBonReception'}.rapprochements.table.${val.name}`;
        acc[val.name] = this.$te(key) ? this.$t(key) : '';
        return acc;
      }, {});
      return {
        texts,
        headings,
        filterable: false,
        sortIcon: tableConfig.SORT_ICON,
        perPage: tableConfig.RESULTS_PER_PAGE,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        sortable: [],
        columnsClasses: {
          codeDcf: 'colonneWith180',
          quantite: 'colonneSelected',
          quantiteARapprocher: 'colonneWith180',
          quantiteResteARapprocher: 'colonneCommentaire',
        },
      };
    },
  },
  methods: {
    setQuantiteValue(value, index) {
      if (!index) return;
      const { rapprochements } = this.data;
      const currentRapprochement = rapprochements[index - 1];
      const somme = rapprochements
        .filter((r) => r.ligneCommandeLieuLivraisonId
          !== currentRapprochement.ligneCommandeLieuLivraisonId,
        )
        .reduce((acc, val) => acc + val.quantite, 0);
      const resteARapprocherLigneBR = this.data.quantite - somme;
      const resteARapprocherLigneCA = currentRapprochement.ligneCommandeLieuLivraison.quantite;
      const resteARapprocher = Math.min(resteARapprocherLigneBR, resteARapprocherLigneCA);
      let montantARapprocher = value || 0;
      if (montantARapprocher > resteARapprocher) {
        montantARapprocher = resteARapprocher;
      }
      currentRapprochement.quantite = montantARapprocher;
      this.$emit('update:rapprochements', rapprochements);
    },
  },
};
</script>
